
<div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
  
</div>